export function isInsolvent(result) {
  const netWorth = Number(result?.netWorth?.amountMinor ?? 0);
  return Number.isFinite(netWorth) && netWorth < 0;
}

export function solvencyLabel(result) {
  return isInsolvent(result) ? 'INSOLVENT' : 'SOLVENT';
}
